/**
 * Auto-expand Shopify's "More payment options" so all payment methods are visible by default
 * Runs on cart page, product pages, cart drawer, and anywhere express checkout appears
 */

(function() {
  'use strict';

  function expandPaymentOptions() {
    // Target all possible "More payment options" elements
    const selectors = [
      // Standard Shopify payment button selectors
      '.shopify-payment-button__more-options',
      '.shopify-payment-button__more-options a',
      '.shopify-payment-button__more-options button',
      '[data-shopify-pay-more-options]',
      'more-payment-options-link',
      'more-payment-options-link a',
      // Details/summary elements
      '.additional-checkout-buttons details summary',
      '.shopify-payment-button details summary',
      // Aria-based selectors
      '[aria-expanded="false"][aria-controls*="payment"]',
      '[aria-expanded="false"][aria-controls*="checkout"]',
    ];

    selectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(el => {
        // For details/summary, open the details
        if (el.tagName === 'SUMMARY') {
          const details = el.closest('details');
          if (details && !details.open) {
            details.open = true;
          }
        }
        // For aria-expanded elements, click to expand
        if (el.getAttribute('aria-expanded') === 'false') {
          el.click();
        }
      });
    });

    // Open any closed <details> elements in payment areas
    const detailsElements = document.querySelectorAll(
      '.additional-checkout-buttons details, ' +
      '.shopify-payment-button details, ' +
      '.cart-drawer details, ' +
      '.cart__ctas details'
    );
    detailsElements.forEach(details => {
      if (!details.open) {
        details.open = true;
      }
    });

    // Find and click any collapsed payment option containers
    const collapsedContainers = document.querySelectorAll('[data-collapsed="true"], [aria-hidden="true"]');
    collapsedContainers.forEach(container => {
      if (container.closest('.shopify-payment-button') || container.closest('.additional-checkout-buttons')) {
        container.removeAttribute('data-collapsed');
        container.removeAttribute('aria-hidden');
        container.style.display = '';
      }
    });
  }

  // Run multiple times to catch dynamically loaded content
  function runExpansion() {
    expandPaymentOptions();
    setTimeout(expandPaymentOptions, 300);
    setTimeout(expandPaymentOptions, 800);
    setTimeout(expandPaymentOptions, 1500);
    setTimeout(expandPaymentOptions, 3000);
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runExpansion);
  } else {
    runExpansion();
  }

  // Watch for dynamic content (cart drawer, AJAX updates, etc.)
  const observer = new MutationObserver((mutations) => {
    let shouldExpand = false;
    for (const mutation of mutations) {
      if (mutation.addedNodes.length > 0) {
        // Check if any added nodes are payment-related
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) { // Element node
            if (node.classList && (
              node.classList.contains('shopify-payment-button') ||
              node.classList.contains('additional-checkout-buttons') ||
              node.querySelector && node.querySelector('.shopify-payment-button')
            )) {
              shouldExpand = true;
            }
          }
        });
      }
    }
    if (shouldExpand) {
      setTimeout(expandPaymentOptions, 100);
      setTimeout(expandPaymentOptions, 500);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Also run when dialogs open (cart drawer)
  document.addEventListener('click', (e) => {
    if (e.target.closest('[aria-haspopup="dialog"]') || e.target.closest('cart-drawer-component')) {
      setTimeout(expandPaymentOptions, 300);
      setTimeout(expandPaymentOptions, 800);
    }
  });
})();
